import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { AssessmentOutlined } from '@mui/icons-material';
import { SectionHeaderWithCommand, SectionPaper } from '../../../../common/components';
import { ReportTypeEditor, ReportTitleEditor, ReportDescriptionEditor } from '../fields/reporting';
import { EditorMode } from '../../../types/editorTypes';

interface ReportingSectionProps {
  mode?: EditorMode;
}

/**
 * ReportingSection - Section for reporting request fields
 * Shown when ticket/recurring task category is "Reporting"
 */
export const ReportingSection: React.FC<ReportingSectionProps> = ({ mode = 'ticket' }) => {
  const title = mode === 'recurringTask' ? 'Reporting Request Template' : 'Reporting Request';

  return (
    <Box>
      <SectionHeaderWithCommand
        icon={<AssessmentOutlined sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />}
        title={title}
      />
      
      <SectionPaper>
        <Stack spacing={3}>
          {/* Report Type Selection */}
          <Box>
            <Typography 
              variant="body2" 
              sx={{ 
                mb: 1, 
                fontWeight: 500, 
                color: '#64748b' 
              }}
            >
              Report Type
            </Typography>
            <ReportTypeEditor mode={mode} />
          </Box>
          
          {/* Title and Description */}
          <Box>
            <Typography 
              variant="body2" 
              sx={{ 
                mb: 1, 
                fontWeight: 500, 
                color: '#64748b' 
              }}
            >
              Report Details
            </Typography>
            <Stack spacing={2}>
              <ReportTitleEditor mode={mode} />
              <ReportDescriptionEditor mode={mode} />
            </Stack>
          </Box>
        </Stack>
      </SectionPaper>
    </Box>
  );
};

export default ReportingSection;
